<script lang="ts">
    import CalculatorShinerBox from "./CalculatorShinerBox.svelte";

    export let number;
    export let color;

    let shineBox;

    $: if (number && shineBox !== null) {
        shineBox.shine();
    }
</script>

<CalculatorShinerBox borderColor={color} bind:this={shineBox}>
    <div
        class="full-w full-h padding-5px center-contents-v font-size-2-rem font-family-bardic-sans"
    >
        {#if number}
            <span class="font-family-bardic-sans">
                {number}
            </span>
        {:else}
            <em class="background-color-pico-background">??</em>
        {/if}
    </div>
</CalculatorShinerBox>
